<template>
  <div class="orderDetail">
    <div class="orderDetail_head">
      <span>一路顺 {{ detailsdata.site_name }}</span>
    </div>
    <div class="orderDetail_content">
            <span class="num_text">
                <!--{{detailsdata.unit_price}}元/升-->
              <span>{{ detailsdata.oil_name }}</span>
                <span>{{ detailsdata.num }}升</span>
              <!--<span>总：{{ detailsdata.pay_money }}元</span>-->
                <span v-show="details_complete" class="iconfont icon-duihao"></span>
                <span v-show="!details_complete" class="iconfont icon-cuo"></span>
            </span>
      <span class="time_text">{{ detailsdata.create_time }}</span>
    </div>
    <div class="bts" v-if="this.app_id !== 'ypt'">
      <div>
        <div @click="goHome">操作成功</div>
      </div>
    </div>
  </div>
</template>

<script>
import common from "../common";
import {Toast} from 'mint-ui';
import wx from "weixin-js-sdk";

export default {
  name: "orderDetail",
  data() {
    return {
      detailsdata: "",
      details_complete: true,//订单是否完成
      token: "",
      value: 0,
      app_id: '',
    }
  },
  methods: {
    goHome() {
      this.$router.replace("/");
    }
  },
  mounted() {
    //读取登录状态：localStorage 优先，cookie 兜底
    let userInfo = common.getUserInfo();
    let url = 'wx/orderDetail';
    if (userInfo) {
      this.token = userInfo.token;
    } else if (this.$router.currentRoute.query.app_id == "ypt") {
      this.app_id = this.$router.currentRoute.query.app_id;
      url = 'wx/ypt/orderDetail';
    } else {
      this.$router.replace({name: 'login'});
    }
    let order_id = this.$router.currentRoute.params.order_id;
    let token = this.token;
    let querystring = require('querystring');
    this.$api.post(url,
        querystring.stringify({
          order_id,
          token
        })
    ).then(data => {
      if (data.data.status == 1) {
        this.detailsdata = data.data.data;
      } else {
        this.details_complete = false;
        common.toast(data.data.msg);
      }
    }).catch(err => {
      console.log(err);
    })
    // wx.getLocation({
    //   type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
    //   success: res => {
    //     let querystring = require('querystring');
    //     this.$api.post('wx/User/getLocation',
    //         querystring.stringify({
    //           latitude: res.latitude,
    //           longitude: res.longitude,
    //           token: token,
    //           action: "order_detail",
    //         })
    //     )
    //   }
    // });
  }
}
</script>

<style>
.orderDetail {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: white;
  display: -webkit-flex;
  flex-direction: column;
  font-size: 30px;
}

.orderDetail > .orderDetail_head {
  background: #f5f5f5;
  width: 100vw;
  height: 5vh;
  padding: 0.5rem 0.5rem;
  line-height: 1rem;
  font-size: 1rem;
  text-align: left;
}

.orderDetail_content {
  width: 100vw;
  height: 500px;
  background: white;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: space-around;
}

.num_text {
  color: #0097fe;
  font-size: 100px;
}

.time_text {
  font-size: 1rem;
}

.orderDetail .icon-cuo {
  font-size: 50px;
}

.orderDetail .icon-duihao {
  font-size: 120px;
}

.orderDetail .bts {
  width: 60vw;
  height: 6vh;
  text-align: center;
  margin: 10vh auto;
  line-height: 6vh;
  color: white;
  font-size: 0.6rem;
  border-radius: 8px;
  font-weight: bold;
  background: #0097fe;
}

.addClass {
  padding: 20px !important;
}

.addClass > span {
  padding-top: 0 !important;
}
</style>
    


// WEBPACK FOOTER //
// src/components/orderDetail.vue